import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { ThemeProvider } from "next-themes";
import { initSentry } from "./lib/sentry";
import { readThemeFromUserSettings } from "./lib/user-settings-storage";
import { UserSettingsThemeSync } from "./components/UserSettingsThemeSync";

// Инициализация Sentry для мониторинга ошибок (должна быть до рендеринга)
initSentry();

if (import.meta.env.DEV && "serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      void registration.unregister();
    });
  });
}

createRoot(document.getElementById("root")!).render(
  <ThemeProvider
    attribute="class"
    defaultTheme={readThemeFromUserSettings()}
    enableSystem
  >
    <UserSettingsThemeSync />
    <App />
  </ThemeProvider>
);
